<template>
  <div class="page-loading" :class="pageLoading ? 'page-loading--active': ''">
    <div v-if="pageLoading" class="spinner" />
    <session-timeout-modal />
    <router-view></router-view>
  </div>
</template>

<script>
import SessionTimeoutModal from '@/components/partials/SessionTimeoutModal.vue'

import axios from 'axios';
import {mapGetters} from "vuex";
import {api} from "@/store/store";

export default {
  props: {

  },
  components: {
    SessionTimeoutModal
  },
  methods: {
    
  },
  ...mapGetters({
      answers: 'flattenedAnswers',
  }),
  mounted () {
    if ( !this.$route.params.session_id ) {
      // get uuid from backend
      this.$store.dispatch('getUUID')
        .then(response => {

          // seed data
          axios.post(
              api.url + api.version + 'vehicle/alt/' + this.$route.params.policy_id + '/' + this.$store.state.session_id
          )
              .then(response => {

                if ( response.data && response.data.results && !( response.data.results.valid == false ) ) {

                  console.log( response.data.results );

                  this.$store.commit('updateBackendData', {
                    'VehicleAlt.Plate': {
                      "vehicle_make": response.data.results.make,
                      "vehicle_model": response.data.results.model,
                      "vehicle_year": response.data.results.year,
                      "vehicle_plate": response.data.results.plate,
                      "vehicle_initial_sum_insured_amount": response.data.results.vehicle_sum_insured_amount,
                    },
                    'VehicleAlt.Confirm': {
                      "initial_full_address": response.data.results.vehicle_confirm_park_address,
                    }
                  });

                  this.$store.commit('updateAnswers',{
                    localActiveStep: 'VehicleAlt.Plate',
                    answers: {
                      "vehicle_plate": response.data.results.plate
                    }
                  });

                  this.$store.commit('setDriver', response.data.results.vehicle_confirm_driver);

                  this.$store.commit('updateAnswers',{
                    localActiveStep: 'VehicleAlt.Confirm',
                    answers: {
                      "vehicle_confirm_driver": response.data.results.vehicle_confirm_driver,
                      "initial_full_address": response.data.results.vehicle_confirm_park_address,
                    }
                  });

                  this.$store.commit('updateAnswers',{
                    localActiveStep: 'VehicleAlt.Quote',
                      answers: {
                        "payment_interval": response.data.results.payment_interval,
                        "vehicle_cover_type": response.data.results.vehicle_cover_type,
                        //"vehicle_sum_insured_amount": response.data.results.vehicle_sum_insured_amount, // this gets set after validation of confirm step (includes potential plate lookup and revalue)
                        "vehicle_low_usage": response.data.results.vehicle_low_usage,
                        "vehicle_include_under25_cover": response.data.results.vehicle_include_under25_cover,
                        "vehicle_include_roadside_assist_cover": response.data.results.vehicle_include_roadside_assist_cover,
                        "vehicle_excess_group": [
                          {
                          "vehicle_excess": response.data.results.vehicle_excess
                          }
                        ]
                      }
                    }
                  );

                  this.$router.push( { name: 'VehicleAlt.Confirm', params: { session_id: this.$store.state.session_id } } );

                } else {
                  // probably not logged in as this policy period id
                  // catch any redirects

                  let redirect_url = response.data.redirect;

                  if ( redirect_url ) {

                    if (process.env.NODE_ENV === 'development') {
                      // only do redirects when not in dev mode to make debugging easier
                      window.alert(`VUE DEV MODE: PREVENTED AUTO-REDIRECT  (Browser would normally redirect to ${redirect_url})`);
                    } else {
                      // Redirect since not in dev mode
                      console.error('API response error, redirecting to error page', redirect_url);
                      window.location = redirect_url;
                    }
                  } else {

                    // login page with redirect set to get back here
                    let redirect_url = "/app/login?redirect=" + window.location.pathname;

                    if (process.env.NODE_ENV === 'development') {
                      // only do redirects when not in dev mode to make debugging easier
                      window.alert(`VUE DEV MODE: PREVENTED AUTO-REDIRECT  (Browser would normally redirect to ${redirect_url})`);
                    } else {
                      window.location = redirect_url;
                    }
                  }
                }

              })
              .catch(error => {
                // session timeout
                console.error(error, "Session Timeout");
              });


          // get all data and push into answers

          // this.$store.commit('updateAnswers',{ localActiveStep: 'VehicleAlt.Plate',
          //   answers: {"vehicle_plate": "ABC123"}
          // });

          // this.$store.commit('updateAnswers',{ localActiveStep: 'VehicleAlt.Confirm',
          //   answers: {
          //     "vehicle_confirm_park_address": {
          //       "vehicle_confirm_park_address_full_address": "6 Garden Place, Hamilton Central, Hamilton",
          //       "vehicle_confirm_park_address_locatio_id": "1305554"
          //     }
          //   }
          // })

          // this.$store.commit('updateAnswers', {
          //   localActiveStep: 'VehicleAlt.Confirm',
          //   answers: {
          //     "vehicle_confirm_park_address": {
          //       "vehicle_confirm_park_address_cant_find": true,
          //       "vehicle_confirm_park_address_flat_unit": "2",
          //       "vehicle_confirm_park_address_street_number": "3",
          //       "vehicle_confirm_park_address_street_address": "Victoria Street, Parkvale, Hastings",
          //       "vehicle_confirm_park_address_street_locatio_id": "9011",
          //       "vehicle_confirm_park_address_displayed_address": "2/3 Victoria Street, Parkvale, Hastings",
          //       "vehicle_confirm_park_address_displayed_locatio_id": "612177"
          //     },
          //
          //     "vehicle_confirm_insurance_start": "26/05/2022",
          //     "vehicle_confirm_driver": "new-driver",
          //     "vehicle_confirm_driver_dob": "01/01/1985",
          //     "vehicle_confirm_driver_gender": "male",
          //     "vehicle_confirm_licence": "full",
          //     "vehicle_confirm_driver_claim_count": "0"
          //   }
          // });
          //
          // this.$store.commit('updateBackendData',{
          //       'VehicleAlt.Plate': {
          //         "vehicle_make":"Mitsubishi",
          //         "vehicle_model":"Delica Space Gear",
          //         "vehicle_year":"1997",
          //         "vehicle_price_low":1600,
          //         "vehicle_price_high":3000,
          //         "vehicle_price_avg":2500,
          //         "vehicle_plate_confirm":"ABC123"
          //       }
          //     }
          // );
          //
          // this.$store.commit('updateBackendData',{
          //       'VehicleAlt.Quote': {
          //         "vehicle_cover_type": "full",
          //         "vehicle_sum_insured_amount": 0,
          //         "vehicle_low_usage": "no",
          //         "vehicle_include_under25_cover": "no",
          //         "vehicle_excess": "400"
          //       }
          //     }
          // );
          //
          // Existing driver example
          // "Vehicle.Confirm": {
          //   "vehicle_confirm_insurance_start": "30/05/2022",
          //   "vehicle_confirm_driver": "395"
          // },





          //this.$router.push( { name: 'VehicleAlt.Confirm', params: { session_id: this.$store.state.session_id } } );
        }, error => {
          if( error === 'login_required' ){
            window.location = "/app/login";
          } else {
            // Need to show a generic error, and somehow report the real error back to the site-owners to understand why
            console.error('No valid UUID error on Vehicle Restore', error); // this will trigger sentry

            // TODO - show client-facing error
          }
        })
      return false;
    }
  },
  computed: {
    pageLoading () {
      return this.$store.state.pageLoading;
    }
  },
  data () {
    return {
    }
  }
}

</script>

<style scoped lang="scss">
  
</style>